import { defineMessages } from 'react-intl'

export const playbookMessages = defineMessages({
  activateAction: {
    defaultMessage: 'Activate',
    description: 'playbook version activate button',
  },
  activateSuccess: {
    defaultMessage: 'Playbook version activated',
    description: 'playbook version activate success notification',
  },
  activeChip: {
    defaultMessage: 'Active',
    description: 'playbook active version chip',
  },
  activeVersionLabel: {
    defaultMessage: 'Active version',
    description: 'playbook field label',
  },
  addPlaybook: {
    defaultMessage: 'Add playbook',
    description: 'playbook create dialog header',
  },
  addVersion: {
    defaultMessage: 'New version',
    description: 'playbook version create dialog header',
  },
  aggregationDelayHelp: {
    defaultMessage:
      'Quiet period after the last customer message before the bot replies, in milliseconds.',
    description: 'playbook aggregation delay field help',
  },
  aggregationDelayLabel: {
    defaultMessage: 'Aggregation delay (ms)',
    description: 'playbook field label',
  },
  appLinkHelp: {
    defaultMessage:
      'Leads captured by this playbook are written to the CRM as the linked app. Linking issues a fresh app token and hands it to the bot — the secret is never shown to anyone.',
    description: 'playbook CRM app link help',
  },
  appLinkTitle: {
    defaultMessage: 'CRM app link',
    description: 'playbook detail card title',
  },
  appNotLinked: {
    defaultMessage: 'Not linked',
    description: 'playbook CRM app empty value',
  },
  appSelectLabel: {
    defaultMessage: 'CRM app',
    description: 'playbook field label',
  },
  createSuccess: {
    defaultMessage: 'Playbook created, live at version 1',
    description: 'playbook create success notification',
  },
  descriptionLabel: {
    defaultMessage: 'Description',
    description: 'playbook field label',
  },
  emptyTable: {
    defaultMessage: 'No playbooks found',
    description: 'playbook list empty state',
  },
  handoffTurnLimitHelp: {
    defaultMessage:
      'Planned handoff. Counts REPLIES THE BOT SENDS, not customer messages: several messages sent in a row get one reply and cost one turn. After this many replies the next customer message goes straight to an operator, with no bot reply. Resets whenever the conversation changes hands. 0 disables.',
    description: 'playbook handoff turn limit field help',
  },
  handoffTurnLimitLabel: {
    defaultMessage: 'Handoff turn limit',
    description: 'playbook field label',
  },
  headTitle: {
    defaultMessage: 'Playbook',
    description: 'playbook detail card title',
  },
  historyLimitLabel: {
    defaultMessage: 'History limit',
    description: 'playbook field label',
  },
  leadCaptureLabel: {
    defaultMessage: 'Lead capture',
    description: 'playbook field label',
  },
  nameHelp: {
    defaultMessage:
      'Display label for the playbook. Campaigns and channels reference the playbook by its id, so the name can be changed later.',
    description: 'playbook name field help',
  },
  nameLabel: {
    defaultMessage: 'Name',
    description: 'playbook field label',
  },
  outcomesHelp: {
    defaultMessage: 'Comma-separated outcome taxonomy the bot may attach when handing off.',
    description: 'playbook outcomes field help',
  },
  outcomesLabel: {
    defaultMessage: 'Outcomes',
    description: 'playbook field label',
  },
  rotateAction: {
    defaultMessage: 'Rotate token',
    description: 'playbook CRM token rotate button',
  },
  rotateSuccess: {
    defaultMessage: 'CRM token rotated',
    description: 'playbook CRM token rotate success notification',
  },
  summaryEnabledLabel: {
    defaultMessage: 'Handoff summary',
    description: 'playbook field label',
  },
  systemPromptHelp: {
    defaultMessage:
      'The complete pinned persona and instructions. A new version must be activated explicitly before it serves traffic.',
    description: 'playbook system prompt field help',
  },
  systemPromptLabel: {
    defaultMessage: 'System prompt',
    description: 'playbook field label',
  },
  tokenNotSet: {
    defaultMessage: 'No token stored',
    description: 'playbook CRM token absent value',
  },
  tokenSet: {
    defaultMessage: 'Token stored',
    description: 'playbook CRM token present value',
  },
  turnLimitHelp: {
    defaultMessage:
      'Failure backstop. Counts CUSTOMER MESSAGES since the conversation last changed hands, whether or not the bot managed to reply — so it still hands off when the bot is stuck or silent. Set it above the handoff limit; the lower one fires first. 0 disables.',
    description: 'playbook turn limit field help',
  },
  turnLimitLabel: {
    defaultMessage: 'Turn limit',
    description: 'playbook field label',
  },
  typeConcierge: {
    defaultMessage: 'Concierge — case in progress',
    description: 'playbook type option label',
  },
  typeHelp: {
    defaultMessage:
      'What this playbook is for, and therefore which campaign and channel slots will accept it. PERMANENT — campaigns and channels reference a playbook by id, so the type can never be changed; fixing a wrong choice means creating a new playbook.',
    description: 'playbook type field help',
  },
  typeIntake: {
    defaultMessage: 'Intake — first contact (unknown sender)',
    description: 'playbook type option label',
  },
  typeLabel: {
    defaultMessage: 'Type',
    description: 'playbook field label',
  },
  typePlaceholder: {
    defaultMessage: 'Choose a type…',
    description: 'playbook type field empty option',
  },
  typeScreening: {
    defaultMessage: 'Screening — campaign pre-screen after our opener',
    description: 'playbook type option label',
  },
  typeSupport: {
    defaultMessage: 'Support — recognised client, no case',
    description: 'playbook type option label',
  },
  typeUntyped: {
    defaultMessage: 'Untyped',
    description: 'playbook type value for a legacy playbook with no type — no slot accepts it',
  },
  versionCreateSuccess: {
    defaultMessage: 'Version created — activate it to make it live',
    description: 'playbook version create success notification',
  },
  versionCreatedLabel: {
    defaultMessage: 'Created',
    description: 'playbook versions table column header: when the version was saved',
  },
  versionLabel: {
    defaultMessage: 'Version',
    description: 'playbook field label',
  },
  versionsTitle: {
    defaultMessage: 'Versions',
    description: 'playbook detail card title',
  },
  viewAction: {
    defaultMessage: 'View',
    description: 'playbook version row — open read-only details',
  },
  viewVersionTitle: {
    defaultMessage: 'Version {version}',
    description: 'playbook version read-only dialog header',
  },
})

/**
 * Weekday toggles of the follow-up send-window editor, keyed by
 * `MessagingSendWindowDay` so `sendWindowDayMessages[day]` resolves directly.
 */
export const sendWindowDayMessages = defineMessages({
  FRI: {
    defaultMessage: 'Fri',
    description: 'send-window weekday toggle — Friday',
  },
  MON: {
    defaultMessage: 'Mon',
    description: 'send-window weekday toggle — Monday',
  },
  SAT: {
    defaultMessage: 'Sat',
    description: 'send-window weekday toggle — Saturday',
  },
  SUN: {
    defaultMessage: 'Sun',
    description: 'send-window weekday toggle — Sunday',
  },
  THU: {
    defaultMessage: 'Thu',
    description: 'send-window weekday toggle — Thursday',
  },
  TUE: {
    defaultMessage: 'Tue',
    description: 'send-window weekday toggle — Tuesday',
  },
  WED: {
    defaultMessage: 'Wed',
    description: 'send-window weekday toggle — Wednesday',
  },
})
